import { render, staticRenderFns } from "./ComponentLogger.vue?vue&type=template&id=4e97a095&scoped=true&"
import script from "./ComponentLogger.vue?vue&type=script&lang=js&"
export * from "./ComponentLogger.vue?vue&type=script&lang=js&"
import style0 from "./ComponentLogger.vue?vue&type=style&index=0&id=4e97a095&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e97a095",
  null
  
)

export default component.exports